(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const pairs = [...root.querySelectorAll('[data-pair]')];
    const pairList = root.querySelector('.asp-pairs');
    const form = root.querySelector('[data-asp-form]');
    const button = form.querySelector('button');
    const error = root.querySelector('.asp-error');
    const labels = root.querySelector('.asp-bundle-data').dataset;
    const offerReady = root.dataset.offerReady === 'true';
    const bogo = root.dataset.bogo === 'true' && Boolean(root.dataset.discountCode);
    let qty = Number(root.querySelector('[data-bundle-choice]:checked').value);
    let busy = false;
    const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: root.dataset.currency || 'USD'}).format(Math.round(n) / 100);
    const options = pair => {
      const values = [];
      pair.querySelectorAll('[data-option]:checked').forEach(input => values[Number(input.dataset.option)] = input.value);
      return values;
    };
    const selected = pair => {
      const values = options(pair);
      return variants.find(v => v.options.every((o, i) => o === values[i]));
    };
    function update() {
      const chosen = pairs.slice(0, qty).map(selected);
      const complete = chosen.every(Boolean);
      const available = complete && chosen.every(v => v.available);
      root.querySelectorAll('[data-offer]').forEach(card => {
        const active = Number(card.dataset.offer) === qty;
        card.classList.toggle('is-selected', active);
        const body = card.querySelector('[data-offer-body]');
        body.hidden = !active;
        if (active && pairList.parentElement !== body) body.append(pairList);
      });
      pairs.forEach((pair, i) => {
        pair.hidden = i >= qty;
        const free = bogo && qty > 1 && i >= qty / 2;
        pair.querySelector('[data-pair-title]').textContent = free ? labels.selectFree : labels.selectPair;
        pair.querySelector('[data-free]').hidden = !free;
        const values = options(pair);
        pair.querySelector('[data-pair-status]').textContent = selected(pair) ? values.map((value, index) => index === 1 ? `${labels.sizeSystem} ${value}` : value).join(' · ') : labels.selectHint;
        pair.querySelectorAll('[data-option]').forEach(input => {
          const index = Number(input.dataset.option);
          const possible = variants.some(v => v.available && v.options[index] === input.value && v.options.every((o, n) => n === index || !values[n] || o === values[n]));
          input.disabled = !possible;
        });
      });
      button.disabled = busy || (complete && !available) || (bogo && qty > 1 && !offerReady);
      root.querySelector('[data-bundle-pending]').hidden = !(bogo && qty > 1 && !offerReady);
      root.querySelector('[data-cta-label]').textContent = complete && !available ? button.dataset.unavailable : button.dataset.addLabel;
      const first = chosen[0] || variants.find(v => v.available) || variants[0];
      const prices = chosen.map(v => v?.price ?? first.price).sort((a, b) => b - a);
      const paid = bogo && qty > 1 ? qty / 2 : qty;
      root.querySelector('[data-total]').textContent = money(prices.slice(0, paid).reduce((a, b) => a + b, 0));
      root.querySelectorAll('[data-unit-price]').forEach(el => el.textContent = money(first.price / (bogo && Number(el.dataset.unitPrice) > 1 ? 2 : 1)));
      root.querySelectorAll('[data-original-price]').forEach(el => el.textContent = money(first.price));
      form.querySelector('input[name=id]').value = first.id;
      form.querySelector('input[name=quantity]').value = qty;
    }
    root.querySelectorAll('[data-bundle-choice]').forEach(input => input.addEventListener('change', () => {qty = Number(input.value); update();}));
    root.querySelectorAll('[data-option]').forEach(input => input.addEventListener('change', () => {error.hidden = true; update();}));
    root.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-slide]').forEach(slide => slide.hidden = slide.dataset.slide !== button.dataset.thumb);
      root.querySelectorAll('[data-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    }));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || (bogo && qty > 1 && !offerReady)) return;
      const chosen = pairs.slice(0, qty).map(selected);
      if (!chosen.every(Boolean)) {error.textContent = labels.selectRequired; error.hidden = false; pairs.slice(0, qty).find(p => !selected(p))?.scrollIntoView({behavior: 'smooth', block: 'center'}); return;}
      if (!chosen.every(v => v.available)) {update(); return;}
      error.hidden = true;
      busy = true;
      update();
      let added = false;
      try {
        const items = chosen.reduce((list, variant) => {
          const existing = list.find(item => item.id === variant.id);
          if (existing) existing.quantity++;
          else list.push({id: variant.id, quantity: 1});
          return list;
        }, []);
        const response = await fetch(root.dataset.addUrl, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add items. Please try again.');
        added = true;
        if (bogo && qty > 1) {
          const discountResponse = await fetch(root.dataset.updateUrl, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({discount: root.dataset.discountCode})});
          const cart = await discountResponse.json();
          if (!discountResponse.ok || !cart.items?.some(item => item.discounts?.some(discount => discount.title?.toUpperCase() === root.dataset.discountCode.toUpperCase()) || item.line_level_discount_allocations?.some(allocation => allocation.discount_application?.title?.toUpperCase() === root.dataset.discountCode.toUpperCase()))) {
            error.textContent = labels.discountError;
            error.hidden = false;
            const link = document.createElement('a');
            link.href = root.dataset.cartUrl;
            link.textContent = ' View cart';
            error.append(link);
            button.disabled = true;
            return;
          }
        }
        window.location.assign(root.dataset.checkoutUrl || '/checkout');
      } catch (err) {
        error.textContent = added ? labels.discountError : err.message;
        error.hidden = false;
        if (added) {
          const link = document.createElement('a');
          link.href = root.dataset.cartUrl;
          link.textContent = ' View cart';
          error.append(link);
        } else {
          busy = false;
          update();
        }
      }
    });
    update();
  }
  function boot() {document.querySelectorAll('[data-aspen]').forEach(init);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

(() => {
  function pad(n) {return String(n).padStart(2, '0');}
  function initExtras(scope) {
    scope.querySelectorAll('[data-countdown]:not([data-ready])').forEach(el => {
      el.dataset.ready = 'true';
      const end = new Date(el.dataset.countdown.replace(' ', 'T')).getTime();
      const out = el.querySelector('[data-timer]');
      if (!end) return;
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) {el.hidden = true; return false;}
        el.hidden = false;
        const s = Math.floor(left / 1000);
        out.textContent = `${pad(Math.floor(s / 3600))}:${pad(Math.floor(s % 3600 / 60))}:${pad(s % 60)}`;
        return true;
      };
      if (tick()) {const t = setInterval(() => {if (!tick()) clearInterval(t);}, 1000);}
    });
    scope.querySelectorAll('[data-open-dialog]:not([data-ready])').forEach(btn => {
      btn.dataset.ready = 'true';
      btn.addEventListener('click', () => document.getElementById(btn.dataset.openDialog)?.showModal());
    });
    scope.querySelectorAll('dialog.asp-dialog:not([data-ready])').forEach(d => {
      d.dataset.ready = 'true';
      d.addEventListener('click', e => {if (e.target === d) d.close();});
      d.querySelector('[data-close]')?.addEventListener('click', () => d.close());
    });
    scope.querySelectorAll('[data-tabs]:not([data-ready])').forEach(group => {
      group.dataset.ready = 'true';
      const buttons = [...group.querySelectorAll('[data-tab-btn]')];
      const target = group.dataset.tabs ? document.getElementById(group.dataset.tabs) : null;
      const select = btn => {
        buttons.forEach(b => {b.setAttribute('aria-selected', String(b === btn)); b.tabIndex = b === btn ? 0 : -1;});
        if (target) {
          target.dataset.active = btn.dataset.tabBtn;
          target.querySelectorAll('[data-tab-panel]').forEach(p => p.hidden = p.dataset.tabPanel !== btn.dataset.tabBtn);
        }
      };
      buttons.forEach((btn, i) => {
        btn.addEventListener('click', () => select(btn));
        btn.addEventListener('keydown', e => {
          const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!step) return;
          const next = buttons[(i + step + buttons.length) % buttons.length];
          next.focus(); select(next);
        });
      });
      if (buttons[0]) select(buttons[0]);
    });
    scope.querySelectorAll('[data-slider]:not([data-ready])').forEach(slider => {
      slider.dataset.ready = 'true';
      const input = slider.querySelector('input');
      const set = () => slider.style.setProperty('--pos', input.value + '%');
      input.addEventListener('input', set); set();
    });
    scope.querySelectorAll('[data-reviews]:not([data-ready])').forEach(wrap => {
      wrap.dataset.ready = 'true';
      const cards = [...wrap.querySelectorAll('[data-rating]')];
      const more = wrap.querySelector('[data-more]');
      const filter = wrap.querySelector('[data-filter]');
      const step = Number(wrap.dataset.step) || 6;
      let shown = step;
      const render = () => {
        const val = filter ? filter.value : 'all';
        const list = cards.filter(c => val === 'all' || c.dataset.rating === val);
        cards.forEach(c => c.hidden = true);
        list.slice(0, shown).forEach(c => c.hidden = false);
        if (more) more.hidden = list.length <= shown;
      };
      filter?.addEventListener('change', () => {shown = step; render();});
      more?.addEventListener('click', () => {shown += step; render();});
      render();
    });
    scope.querySelectorAll('[data-sticky]:not([data-ready])').forEach(bar => {
      bar.dataset.ready = 'true';
      const anchor = document.querySelector(bar.dataset.sticky);
      if (!anchor || !('IntersectionObserver' in window)) return;
      bar.hidden = false;
      new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.inert = !past;
      }).observe(anchor);
      bar.inert = true;
    });
  }
  const boot = () => initExtras(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => initExtras(e.target));
})();
